module.exports = __webpack_public_path__ + "media/images/banner/tcvb/tcvb-zh-hans-e38b444ff21523507522556f1616bc0d.jpg";